module.exports = __webpack_public_path__ + "img/ido_icon.817b70b8.svg";